module.exports = "<template> <div class=gmr-display> <pre textcontent.bind=text></pre> </div> </template> ";